import request from '@/utils/request'


// 查询商品信息列表
export function listGoods(query) {
    return request({
        url: '/h5/goods/list',
        method: 'get',
        params: query
    })
}

// 查询商品信息详情
export function listGoodsById(id) {
    return request({
        url: '/h5/goods/'+id,
        method: 'get',
    })
}

// 查询热门商品信息列表
export function listHotGoods() {
    return request({
        url: '/h5/goods/hot/list',
        method: 'get',
    })
}
